import React from "react";
import { Construction } from "lucide-react";
import { PageHeader, Panel } from "../lib/ui";

export default function ComingSoon({ title }) {
  return (
    <div data-testid="coming-soon-page">
      <PageHeader title={title} subtitle="Modul ini sedang disiapkan" />
      <Panel>
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <div className="w-14 h-14 rounded-2xl bg-taupe/15 flex items-center justify-center mb-4">
            <Construction className="w-7 h-7 text-taupe" />
          </div>
          <h3 className="font-heading text-lg text-cocoa">Segera Hadir</h3>
          <p className="text-sm text-wmuted mt-1 max-w-md">
            Fitur <span className="font-semibold text-cocoa">{title}</span> akan tersedia pada rilis modul berikutnya.
          </p>
        </div>
      </Panel>
    </div>
  );
}
